import { OrderIndData, OrderIndListData, OrderIndListDataParams, OrderIndFilter } from "../types";
import { User } from "../../../auth/types";
import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { Employee } from "../../../listing/employees/types";

const getAllOrderIndApi = (
  user: User,
  page: number,
  itemsPerPage: number,
  filter?: OrderIndFilter,
) => {

  const params: OrderIndListDataParams = {
    userid: user.userId,
    fromrow: page * itemsPerPage,
    numofrows: itemsPerPage,
    datefrom: getParamsDateString(filter?.datefrom),
    dateto: getParamsDateString(filter?.dateto),
    prodid: filter?.product?.prodId,
    status: filter?.status,
    brokerid: filter?.brokerid?.empId,
    side: filter?.side,
    qtyfrom: filter?.qtyfrom,
    qtyto: filter?.qtyto,
  };

  console.log("getorderindicativelist params:", params);

  return webApiWithResponse<OrderIndListData[]>({
    method: "GET",
    url: "order/getorderindicativelist",
    params,
  });
};

export default getAllOrderIndApi;
